module.exports = __webpack_public_path__ + "assets/57662699249bae5a4c101e46628b135f.json";